// A leaf whose compile throws is recompiled on every reactive read; log each distinct failure once (task 141).
const reported = new Set();

// eslint-disable-next-line no-console
export function reportOptionCompileFailure(failure, log = console.error) {
  const { className, rawValue, themeId, themeMode, error, optionKey, elementId } = failure;
  let rawKey;
  try {
    rawKey = JSON.stringify(rawValue);
  } catch {
    rawKey = String(rawValue);
  }
  const key = [className, elementId, optionKey, themeId, themeMode, rawKey].join("|");
  if (reported.has(key)) {
    return;
  }
  reported.add(key);
  const where = elementId === undefined || elementId === null ? "unknown element" : `element ${elementId}`;
  log(
    `[dynamic-option] ${className ?? "option"}.convertConfigValueToCompiledValue threw for ${where}, `
    + `option "${optionKey ?? "?"}" (${themeMode}); falling back to the raw value. Logged once per value.`,
    { rawValue, themeId, themeMode, error },
  );
}

export function resetOptionCompileFailureLog() {
  reported.clear();
}
